import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 9v12m-8 -8a8 8 0 0 0 16 0m1 0h-2m-14 0h-2","key":"svg-0"}],["path",{"d":"M9 6a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-1"}]]

/**
 * IconAnchor
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYW5jaG9yIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xMiA5djEybS04IC04YTggOCAwIDAgMCAxNiAwbTEgMGgtMm0tMTQgMGgtMiIgLz4KICA8cGF0aCBkPSJNOSA2YTMgMyAwIDEgMCA2IDBhMyAzIDAgMSAwIC02IDAiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/anchor
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconAnchor = createReactComponent('outline', 'anchor', 'Anchor', __iconNode);

export default IconAnchor;